import React from 'react';
import { connect } from 'react-redux'
import { updateBoard, switchPlayer, setLevel, setWinner, setErrorMessage, setPlayerColor, setPlayOrder, setOpenPlayOrderDialog} from '../../actions/index';
import Slot from "../Slot/Slot";
import Column from "../Column/Column";
import "./GameBoard.css"
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const WIN = 5120;
const LOSS = -5120;
const BOT = 2;
const HUMAN = 1;
const CENTER_FIRST_COLS = [3, 2, 4, 1, 5, 0, 6];

class ConnectedGameBoard extends React.Component {
	constructor(props) {
		super(props);
	}

	handleCloseDialog = (playOrder) => {
	    this.props.setPlayOrder(playOrder);
	    this.props.setOpenPlayOrderDialog(false);
	    if (playOrder === 2) {
			var board = Array(7).fill().map(() => Array(6).fill(0));
			this.botMove(board);
			this.props.updateBoard(board);
		}
	  };

	handleSetupLevel = (level) => {
		this.props.setLevel(level);
	}

	handleSetupColor = (color) => {
		this.props.setPlayerColor(color);
	}

	handleUpdateBoard = (col) => {
		if (this.props.winner !== 0) return;
		var board = [];
		var columnFull = false;
		var row = -1;
		for (var i = 0; i < 7; i++) {
			var column = []
			for (var j = 0; j < 6; j++) {
				if (i !== col) {
					column.push(this.props.board[i][j])
				} else {
					if (this.props.board[col][j] === 0) {
						column.push(this.props.currentPlayer);
						row = j;
						for (var k = j + 1; k < 6; k++) {
							column.push(0);
						}
						break;
					} else {
						column.push(this.props.board[i][j])
					}
					if (j === 5) {
						columnFull = true;
					}
				}
			}
			board.push(column);
		}

		if (columnFull) {
			const errorMessage = "Column " + (col + 1) + " is already full. Please select another column."
			this.props.setErrorMessage(errorMessage);
		} else {
			this.props.setErrorMessage("");

			if (this.checkWinCondition(board, col)) {
				this.props.updateBoard(board);
				this.props.setWinner(this.props.currentPlayer);
			} else if (this.checkTieCondition(board)) {
				this.props.updateBoard(board);
				this.props.setWinner(3);
			} else {
				this.botMove(board);
				this.props.updateBoard(board);
			}
		}
	}

	checkWinCondition = (board, col) => {
		if (col < 0) return false;

		var row = -1;
		for (var i = 5; i >= 0; i--) {
			if (board[col][i] !== 0) {
				row = i;
				break;
			}
		}
		if (row < 0) return false;

		var value = board[col][row];

		var downRow = row + 1;
		var upRow = row - 1;
		var sumRow = 1;
		while (downRow < 6 && board[col][downRow] === value) {
			downRow++;
			sumRow++;
		}

		while (upRow >= 0 && board[col][upRow] === value) {
			upRow--;
			sumRow++;
		}

		if (sumRow >= 4)
			return true;

		var leftCol = col - 1;
		var rightCol = col + 1;
		var sumCol = 1;
		while (leftCol >= 0 && board[leftCol][row] === value) {
			leftCol--;
			sumCol++;
		}

		while (rightCol < 7 && board[rightCol][row] === value) {
			rightCol++;
			sumCol++;
		}

		if (sumCol >= 4)
			return true;

		leftCol = col - 1;
		downRow = row + 1;
		var sumPosDiagonal = 1;
		while (leftCol >= 0 && downRow < 6 && board[leftCol][downRow] === value) {
			leftCol--;
			downRow++;
			sumPosDiagonal++;
		}

		rightCol = col + 1;
		upRow = row - 1;
		while (rightCol < 7 && upRow >= 0 && board[rightCol][upRow] === value) {
			rightCol++;
			upRow--;
			sumPosDiagonal++;
		}
		if (sumPosDiagonal >= 4)
			return true;

		leftCol = col - 1;
		upRow = row - 1;
		var sumNegDiagonal = 1;
		while (leftCol >= 0 && upRow >= 0 && board[leftCol][upRow] === value) {
			leftCol--;
			upRow--;
			sumNegDiagonal++;
		}

		rightCol = col + 1;
		downRow = row + 1;
		while (rightCol < 7 && downRow < 6 && board[rightCol][downRow] === value) {
			rightCol++;
			downRow++;
			sumNegDiagonal++;
		}
		if (sumNegDiagonal >= 4)
			return true;

		return false;
	}

	restartGame = () => {
		var r = window.confirm("Do you want to start a new game?");
		if (r === true) {
			var board = [[0, 0, 0, 0, 0, 0],
			[0, 0, 0, 0, 0, 0],
			[0, 0, 0, 0, 0, 0],
			[0, 0, 0, 0, 0, 0],
			[0, 0, 0, 0, 0, 0],
			[0, 0, 0, 0, 0, 0],
			[0, 0, 0, 0, 0, 0]];
			this.props.setErrorMessage("");
			this.props.setWinner(0);
			this.props.updateBoard(board);
			this.props.setOpenPlayOrderDialog(true);
		}
	}

	getValidCols = (board) => {
		return CENTER_FIRST_COLS.filter(col => board[col][5] === 0);
	}

	isPlayableCell = (board, col, row) => {
		return board[col][row] === 0 && (row === 0 || board[col][row - 1] !== 0);
	}

	/**
	 * Evaluate a length 4 segment. Coordinates are included so empty cells can be
	 * scored differently when they are immediately playable under gravity.
	 */
	evalWindow = (board, cells) => {
		var botCount = 0;
		var humanCount = 0;
		var emptyCells = [];
		var playableEmptyCount = 0;

		for (var i = 0; i < cells.length; i++) {
			var col = cells[i][0];
			var row = cells[i][1];
			var value = board[col][row];

			if (value === BOT) {
				botCount++;
			} else if (value === HUMAN) {
				humanCount++;
			} else {
				emptyCells.push([col, row]);
				if (this.isPlayableCell(board, col, row)) {
					playableEmptyCount++;
				}
			}
		}

		if (botCount > 0 && humanCount > 0)
			return 0;
		if (botCount === 4)
			return WIN;
		if (humanCount === 4)
			return LOSS;

		if (botCount === 3 && emptyCells.length === 1)
			return playableEmptyCount === 1 ? 900 : 250;
		if (humanCount === 3 && emptyCells.length === 1)
			return playableEmptyCount === 1 ? -1200 : -300;
		if (botCount === 2 && emptyCells.length === 2)
			return playableEmptyCount > 0 ? 120 : 60;
		if (humanCount === 2 && emptyCells.length === 2)
			return playableEmptyCount > 0 ? -160 : -80;
		if (botCount === 1 && emptyCells.length === 3)
			return 10;
		if (humanCount === 1 && emptyCells.length === 3)
			return -10;

		return 0;
	}

	/**
	 * Return a static evaluation score of the current board state.
	 * Positive values favor the bot. Negative values favor the human.
	 */
	staticEval = (board) => {
		var value = 0;

		for (var row = 0; row < 6; row++) {
			if (board[3][row] === BOT) {
				value += 30;
			} else if (board[3][row] === HUMAN) {
				value -= 30;
			}
		}

		var addWindowScore = (cells) => {
			var score = this.evalWindow(board, cells);
			if (score === WIN || score === LOSS) return score;
			value += score;
			return null;
		};

		for (var col = 0; col < 7; col++) {
			for (row = 0; row < 3; row++) {
				var terminal = addWindowScore([[col, row], [col, row + 1], [col, row + 2], [col, row + 3]]);
				if (terminal !== null) return terminal;
			}
		}

		for (row = 0; row < 6; row++) {
			for (col = 0; col < 4; col++) {
				terminal = addWindowScore([[col, row], [col + 1, row], [col + 2, row], [col + 3, row]]);
				if (terminal !== null) return terminal;
			}
		}

		for (col = 0; col < 4; col++) {
			for (row = 0; row < 3; row++) {
				terminal = addWindowScore([[col, row], [col + 1, row + 1], [col + 2, row + 2], [col + 3, row + 3]]);
				if (terminal !== null) return terminal;
			}
		}

		for (col = 0; col < 4; col++) {
			for (row = 3; row < 6; row++) {
				terminal = addWindowScore([[col, row], [col + 1, row - 1], [col + 2, row - 2], [col + 3, row - 3]]);
				if (terminal !== null) return terminal;
			}
		}

		return value;
	}

	/**
	 * Finds an immediate winning move for a player, or -1 if none exists.
	 */
	findWinningMove = (board, player) => {
		var columns = this.getValidCols(board);

		for (var i = 0; i < columns.length; i++) {
			var col = columns[i];
			this.placeToken(board, player, col);
			var wins = this.checkWinCondition(board, col);
			this.removeToken(board, col);

			if (wins) return col;
		}

		return -1;
	}

	/**
	 * Single minimax implementation with alpha-beta pruning.
	 * maximizing=true means it is the bot's turn.
	 */
	minimax = (board, depth, alpha, beta, maximizing) => {
		var val = this.staticEval(board);

		if (val === WIN) return [WIN + depth, -1];
		if (val === LOSS) return [LOSS - depth, -1];
		if (depth === 0) return [val, -1];

		var columns = this.getValidCols(board);
		if (columns.length === 0) return [val, -1];

		var bestMove = columns[0];

		if (maximizing) {
			var bestValue = -1000000;

			for (var i = 0; i < columns.length; i++) {
				var col = columns[i];
				this.placeToken(board, BOT, col);
				var score = this.minimax(board, depth - 1, alpha, beta, false)[0];
				this.removeToken(board, col);

				if (score > bestValue) {
					bestValue = score;
					bestMove = col;
				}

				alpha = Math.max(alpha, bestValue);
				if (beta <= alpha) break;
			}

			return [bestValue, bestMove];
		}

		bestValue = 1000000;

		for (i = 0; i < columns.length; i++) {
			col = columns[i];
			this.placeToken(board, HUMAN, col);
			score = this.minimax(board, depth - 1, alpha, beta, true)[0];
			this.removeToken(board, col);

			if (score < bestValue) {
				bestValue = score;
				bestMove = col;
			}

			beta = Math.min(beta, bestValue);
			if (beta <= alpha) break;
		}

		return [bestValue, bestMove];
	}

	/**
	 * Place a token in a column on the board.
	 * @param col Column to place a token in
	 */
	placeToken = (board, currentPlayer, col) => {
		for (var i = 0; i < 6; i++) {
			if (board[col][i] === 0) {
				board[col][i] = currentPlayer;
				break;
			}
		}
	}

	/**
	 * Remove a token from the board. This is used for recursive backtracking in minimax.
	 * @param col
	 */
	removeToken = (board, col) => {
		for (var i = 5; i >= 0; i--) {
			if (board[col][i] !== 0) {
				board[col][i] = 0;
				break;
			}
		}
	}

	/**
	 * Connecto-bot move logic
	 */
	botMove = (board) => {
		var botLevel = this.props.level;
		var col = -1;

		if (botLevel === 1) {
			col = this.getRandomMove(board);
		} else {
			col = this.findWinningMove(board, BOT);

			if (col < 0) {
				col = this.findWinningMove(board, HUMAN);
			}

			if (col < 0) {
				var depthByLevel = {
					2: 2,
					3: 3,
					4: 4,
					5: 7
				};
				var depth = depthByLevel[botLevel] || 4;
				col = this.minimax(board, depth, -1000000, 1000000, true)[1];
			}
		}

		if (col >= 0) {
			this.placeToken(board, BOT, col);
		}

		if (this.checkWinCondition(board, col)) {
			this.props.setWinner(BOT);
		} else if (this.checkTieCondition(board)) {
			this.props.setWinner(3);
		}
	}

	/**
	 * Check if the board is full.
	 * @return true if the board is full, false otherwise.
	 */
	checkTieCondition = (board) => {
		for (var i = 0; i < 7; i++) {
			if (board[i][5] == 0) {
				return false;
			}
		}
		return true;
	}

	/**
	 * Get a random valid column.
	 * @return
	 */
	getRandomMove = (board) => {
		var columns = this.getValidCols(board);
		var col = columns[Math.floor(Math.random()*columns.length)];
		return col;
	}

	getStatusMessage = () => {
		if (this.props.errorMessage !== "") return this.props.errorMessage;
		if (this.props.winner === HUMAN) return "You won. Beautiful finish.";
		if (this.props.winner === BOT) return "Connecto-bot has won.";
		if (this.props.winner === 3) return "It's a tie.";
		if (this.props.openDialog) return "Finish setup to start.";
		return "Your turn. Pick a column.";
	}

	render() {
		const board = this.props.board;
		const difficultyOptions = [
			{label: "Beginner", value: 1},
			{label: "Easy", value: 2},
			{label: "Medium", value: 3},
			{label: "Hard", value: 4},
			{label: "Advanced", value: 5}
		];
		const colorOptions = ["#7fff00", "#fc6e22", "#01ffff", "#01ffc3"];
		const statusClassName = this.props.errorMessage !== "" ? "game-status error" :
			this.props.winner === HUMAN ? "game-status player-win" :
			this.props.winner === BOT ? "game-status bot-win" :
			this.props.winner === 3 ? "game-status tie" :
			"game-status";

		return (
			<div className="game-container">
				<Dialog
					disableBackdropClick
      				disableEscapeKeyDown
			        open={this.props.openDialog}
			        onClose={this.handleCloseDialog}
			        aria-labelledby="player-order-dialog-title"
			        aria-describedby="player-order-dialog-description"
			        id="player-order-dialog"
			      >
			        <DialogTitle id="player-order-dialog-title">{"Set Up Your Match"}</DialogTitle>
			        <DialogContent>
			          <DialogContentText id="player-order-dialog-description">
			            Pick your settings, then choose who makes the opening move.
			          </DialogContentText>
					  <div className="setup-card">
						  <div className="setup-step-label">1. Match settings</div>
						  <div className="setup-section">
						  	<div className="setup-label">Difficulty</div>
						  	<div className="setup-options difficulty-options">
						  		{
						  			difficultyOptions.map(option => (
						  				<Button
						  					key={"setup-level-" + option.value}
						  					onClick={() => this.handleSetupLevel(option.value)}
						  					className={this.props.level === option.value ? "setup-option active" : "setup-option"}
						  				>
						  					{option.label}
						  				</Button>
						  			))
						  		}
						  	</div>
						  </div>
						  <div className="setup-section">
						  	<div className="setup-label">Your Color</div>
						  	<div className="setup-options color-options">
						  		{
						  			colorOptions.map(color => (
						  				<Button
						  					key={"setup-color-" + color}
						  					onClick={() => this.handleSetupColor(color)}
						  					className={this.props.player1Color === color ? "color-option active" : "color-option"}
						  					aria-label={"Choose " + color}
						  				>
						  					<span className="setup-color-dot" style={{backgroundColor: color}}></span>
						  				</Button>
						  			))
						  		}
						  	</div>
						  </div>
					  </div>
					  <div className="setup-start-section">
					  	<div>
					  		<div className="setup-step-label">2. Start the game</div>
					  		<div className="setup-start-helper">Choose the opening move. The match begins immediately.</div>
					  	</div>
					  	<div className="start-choice-grid">
					  		<Button onClick={() => this.handleCloseDialog(1)} className="first-player-option start-choice primary-start">
					  			<span className="start-choice-title">I’ll Start</span>
					  			<span className="start-choice-copy">You drop the first piece</span>
					  		</Button>
					  		<Button onClick={() => this.handleCloseDialog(2)} className="second-player-option start-choice">
					  			<span className="start-choice-title">Bot Starts</span>
					  			<span className="start-choice-copy">Connecto-bot opens</span>
					  		</Button>
					  	</div>
					  </div>
			        </DialogContent>
			      </Dialog>
				<div className="game-panel">
					<div className="game-panel-header">
						<div className={statusClassName} style={this.props.winner === HUMAN ? {color: this.props.player1Color} : {}}>
							{this.getStatusMessage()}
						</div>
						<div className="turn-legend">
							<div className="legend-item">
								<span className="legend-dot player-dot" style={{backgroundColor: this.props.player1Color}}></span>
								You
							</div>
							<div className="legend-item">
								<span className="legend-dot bot-dot"></span>
								Bot
							</div>
						</div>
					</div>
					<div className="board-frame">
						<div className="game-board">
							{
								board.map((column, colNum) => {
									var columnElements = [];
									[5, 4, 3, 2, 1, 0].map((rowNum) => {
										columnElements.push(<Slot key={"slot-" + colNum + "-" + rowNum} onClick={() => this.handleUpdateBoard(colNum)} value={column[rowNum]} row={rowNum} col={colNum} />);
									})
									return (<Column key={"column-" + colNum} content={columnElements} col={colNum} onClick={() => this.handleUpdateBoard(colNum)}/>);
								})
							}
						</div>
					</div>
				</div>

				<button className="restart-button" onClick={() => this.restartGame()}>
					Restart
				</button>
			</div>
		)
	}
}

const mapStateToProps = state => {
    return {
        board: state.board,
        currentPlayer: state.currentPlayer,
        level: state.botLevel,
        winner: state.winner,
        errorMessage: state.errorMessage,
        player1Color: state.player1Color,
        playOrder: state.playOrder,
        openDialog: state.openPlayOrderDialog
    }
}

const mapDispatchToProps = dispatch => {
	return {
		updateBoard: newBoard => {
			dispatch(updateBoard(newBoard))
		},
		switchPlayer: nextPlayer => {
			dispatch(switchPlayer(nextPlayer))
		},
		setLevel: newLevel => {
			dispatch(setLevel(newLevel))
		},
		setWinner: winner => {
			dispatch(setWinner(winner))
		},
		setErrorMessage: errorMessage => {
			dispatch(setErrorMessage(errorMessage))
		},
		setPlayerColor: newColor => {
			dispatch(setPlayerColor(newColor))
		},
		setPlayOrder: playOrder => {
			dispatch(setPlayOrder(playOrder))
		},
		setOpenPlayOrderDialog: openPlayOrderDialog => {
			dispatch(setOpenPlayOrderDialog(openPlayOrderDialog))
		}
	}
}

const GameBoard = connect(mapStateToProps, mapDispatchToProps)(ConnectedGameBoard);

export default GameBoard;
